/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Metadata used for Payments on hold */
export interface PaymentsOnHoldMetadata {
  /** Definitions of filters available */
  filterDefinitions: PaymentsOnHoldDefinition;
  /** Definitions of sort methods available */
  sortDefinitions: PaymentsOnHoldDefinition;
}

/** Metadata definition for Payments on Hold */
export interface PaymentsOnHoldDefinition {
  /** localized label for the metadata */
  displayName: string;
  /** a key-value pair array of options */
  inputs: any[];
}

/** a list of metadata options for the input definition */
export type PaymentsOnHoldDefinitionInputs = KeyValuePair[];

/** Request to load the payments on hold details. */
export interface PostSalePaymentsOnHoldRequest {
  /** Post Sale - Payments on hold filter being applied. */
  filter: PaymentsOnHoldFilter;
}

/** Request to upload document related to a payment on hold. */
export interface PostSalePaymentsOnHoldUploadDocRequest {
  /** Trade ID */
  tradeId: number;
  /** Type of document being uploaded */
  documentType: any;
  /** Array of file types */
  fileTypes: string[];
}

/** Request to update payment on hold document status. */
export interface PostSalePaymentsOnHoldUpdateDocStatusRequest {
  /** Array of documents to upload in byte format */
  documentIds: number[];
  /** True if documents where successfully uploaded, false otherwise */
  isUploaded: boolean;
}

/** Request to submit documents related to a payment on hold. */
export interface PostSalePaymentsOnHoldSubmitDocRequest {
  /** Trade ID for the payment on hold trade */
  tradeId: number;
  /** Type of document being uploaded */
  documentType: number;
  /** Vin of the vehicle for the payment on hold trade */
  vin: string;
}

/** Response payload containing uploaded payment on hold file information. */
export interface PostSalePaymentsOnHoldUploadDocResponse {
  /** Array of presigned file urls */
  presignedS3Uris: string[];
  /** Array of document Ids */
  documentIds: number[];
}

/** List of definitions that will serve as filter. */
export interface PaymentsOnHoldFilter {
  /** the key of the filter being used. */
  id: number;
}

/** Contains the summary of payments on hold. */
export interface PostSaleSummary {
  /** A user-friendly, localized currency string used to display the total based on the request criteria. */
  amountOnHold: string;
  /** number of trades on this status */
  totalNumberOfTrades: number;
  /** List of requirements */
  requirements: PostSaleSummaryRequirementList;
}

/** List of requirements */
export type PostSaleSummaryRequirementList = PostSaleSummaryRequirement[];

/** A key-value object that includes label translated, the total amount of trades under the requirement and total amount on hold for the required document (lien release letter, title, etc.) */
export interface PostSaleSummaryRequirement {
  /** the requirement label translated */
  label: string;
  /** localized currency string to display the total amount on hold for the requirement */
  onHold: string;
  /** number of trade in the status for the requirement */
  totalNumberOfTrades: number;
}

export type NegotiationProposalNegotiationProposalUserType = 'SELLER' | 'TOP_BIDDER' | 'SECOND_BIDDER';

export type NegotiationActionType = 'PROPOSAL' | 'TIMER_EXPIRED' | 'DECLINED' | 'ACCEPTED' | 'FINAL_ASKING_PRICE';

/** Proposal information. */
export interface NegotiationProposal {
  /**
   * The ID of the the proposal.
   * @format int64
   */
  id: number;
  /**
   * The price proposed.
   * @format int32
   */
  price: number;
  /** The comment associated with the proposal. */
  comment: string | null;
  userSeller?: boolean;
  /**
   * The ID of the user that made the proposal.
   * @format int64
   */
  userId: number;
  /**
   * The ID of the user dealer that made the proposal.
   * @format int64
   */
  dealerId?: number | null;
  /**
   * The date and time that the proposal was made.
   * @format dateTime
   */
  time: string | null;
  /**
   * Determine if this is a stay firm proposal.
   * @default false
   */
  stayFirm: boolean;
  /** Dealership name */
  fullName?: string | null;
  /** Two letter initial of the user */
  userInitials?: string | null;
  /** Full name of the user */
  userName?: string | null;
  recipient?: NegotiationProposalNegotiationProposalUserType;
  initiator?: NegotiationProposalNegotiationProposalUserType;
  actionType?: NegotiationActionType;
  /** Determine if the user that made the proposal is the seller. */
  isUserSeller: boolean;
}

/** A request to create a new proposal for the current negotiation on an auction. */
export interface NegotiationCreateRequest {
  /**
   * The price proposed for the current negotiation.
   * @format int32
   */
  price: number;
  /** If true, then this is a seller negotiation stay firm. */
  stayFirm?: boolean;
  /** The comment associated with the proposal. */
  comment: string;
}

/** NegotiationState: `buyer_offer` - Only one offer initiated by buyer `buyer_counter` - Counter offer by buyer `buyer_firm` - Buyer stat firm `seller_offer` - Only one offer initiated by seller `seller_counter` - Counter offer by seller `final_asking_price` - Offer sent to second bidder `declined` - Offer declined or Trade expired `no_negotiation` - No negotiation created `accepted` - Offer accepted  */
export type NegotiationState =
  | 'NO_NEGOTIATION'
  | 'IN_PROGRESS'
  | 'REJECTED'
  | 'ACCEPTED'
  | 'FINAL_ASKING_PRICE'
  | 'buyer_offer'
  | 'buyer_counter'
  | 'buyer_firm'
  | 'seller_offer'
  | 'seller_counter'
  | 'final_asking_price'
  | 'declined'
  | 'no_negotiation'
  | 'accepted';

/** A list of `Proposal` objects and the state of the Negotiation based on the authenticated user. */
export interface NegotiationListResponse {
  /** If the accept option should be shown to the user. */
  canAccept: boolean;
  /** If the reject option should be shown to the user. */
  canReject: boolean;
  /** If the counter option should be shown to the user. */
  canCounter: boolean;
  /** If the stay firm option should be shown to the user. */
  canStayFirm: boolean;
  /** NegotiationState: `buyer_offer` - Only one offer initiated by buyer `buyer_counter` - Counter offer by buyer `buyer_firm` - Buyer stat firm `seller_offer` - Only one offer initiated by seller `seller_counter` - Counter offer by seller `final_asking_price` - Offer sent to second bidder `declined` - Offer declined or Trade expired `no_negotiation` - No negotiation created `accepted` - Offer accepted  */
  negotiationState: NegotiationState;
  /**
   * Proxy amount set by buyer on the auction
   * @format int32
   */
  proxyAmount?: number | null;
  /**
   * Auction top bid value
   * @format int32
   */
  topBid?: number;
  /**
   * Floor price set by seller for the auction
   * @format int32
   */
  floorPrice?: number | null;
  /** @format int32 */
  highBidThreshold?: number | null;
  /** @format int32 */
  minBidThreshold?: number | null;
  proposals?: NegotiationProposal[];
}

/** A response that contains the new trade state of the moved negotiation. */
export interface NegotiationProposalUpdateResponse {
  /**
   * The current state of the trade.
   * @format int32
   */
  tradeState: number;
}

export type NegotiationProposalUpdateRequestNegotiationProposalState = 'ACCEPTED' | 'REJECTED';

/** A request to move a negotiation to a specified state. */
export interface NegotiationProposalUpdateRequest {
  state: NegotiationProposalUpdateRequestNegotiationProposalState;
}

/** A request up update dealer auto win setting. */
export interface AutoWinSettingUpdateRequest {
  /** Boolean representing if dealer auto win setting is on or off. */
  autoWinEnabled: boolean;
}

/** Dealer autowin setting response. */
export interface AutoWinSettingResponse {
  /** Boolean representing if dealer auto win setting is on or off. */
  autoWinEnabled: boolean;
}

/** The list view type enum. */
export type UserListViewPreferenceType = 'LIST' | 'GRID';

/** Contains user preferences. */
export interface UserPreferenceResponse {
  /** The list view type enum. */
  listView: UserListViewPreferenceType;
}

/** A request to update user preference. */
export interface UserPreferenceRequest {
  /** The list view type enum. */
  listView?: UserListViewPreferenceType;
}

export interface TradeSummaryList {
  tradeSummaries?: TradeSummaryListTradeSummary[];
}

export interface TradeSummaryListTradeSummary {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  tradeState?: number;
  tradeVehicleSummary?: TradeSummaryListTradeSummaryTradeVehicleSummary;
  auctionSummary?: TradeSummaryListTradeSummaryAuctionSummary;
  statusSummary?: string | null;
  /** @format int32 */
  mileage?: number;
  /** @format int32 */
  odometerType?: number;
  transmissionType?: IdDisplayNamePair;
  statusDates?: TradeSummaryListTradeSummaryStatusDates;
  vin?: string;
  researchSummary?: TradeSummaryListTradeSummaryResearchSummary;
}

export interface TradeSummaryListTradeSummaryTradeVehicleSummary {
  vehicleSummary?: TradeSummaryListTradeSummaryTradeVehicleSummaryVehicleSummary;
  thumbnailUrl?: string | null;
}

export interface TradeSummaryListTradeSummaryTradeVehicleSummaryVehicleSummary {
  /** @format int32 */
  modelYear?: number;
  model?: TradeSummaryListTradeSummaryTradeVehicleSummaryVehicleSummaryModel;
  trim?: string;
}

export interface TradeSummaryListTradeSummaryTradeVehicleSummaryVehicleSummaryModel {
  displayName?: string;
  manufacturerName?: string;
}

export interface TradeSummaryListTradeSummaryAuctionSummary {
  /** @format int32 */
  maxBid?: number;
}

export interface IdDisplayNamePair {
  /** @format int32 */
  id?: number;
  displayName?: string;
}

export interface TradeSummaryListTradeSummaryStatusDates {
  /** @format int64 */
  acquired?: number;
}

export interface TradeSummaryListTradeSummaryResearchSummary {
  color?: string;
  engine?: string;
  location?: string;
  optionCodes?: string;
  announcements?: string;
}

export interface AdesaResearchRequestResearchTradeRequest {
  researchRequest?: AdesaResearchRequestResearchTradeRequestResearchRequest;
  pagination?: AdesaResearchRequestResearchTradeRequestTradeListPagination;
  /** @format int32 */
  source?: number | null;
}

export interface AdesaResearchRequestResearchTradeRequestResearchRequest {
  /** @format int32 */
  modelYear?: number;
  modelId?: number[];
  /** @format int32 */
  modelYearTo?: number;
  manufacturerId?: number[];
  manufacturer?: InputListDefinition;
  model?: string[] | null;
  trim?: string[] | null;
  trimId?: number[] | null;
  mileageRange?: AdesaResearchRequestResearchTradeRequestResearchRequestMileageRange;
  transmission?: AdesaResearchRequestResearchTradeRequestResearchRequestTransmission[] | null;
  driveTrain?: InputListDefinition[] | null;
  engine?: InputListDefinition[] | null;
  inputDefinitions?: KeyValuePair[];
}

export interface InputListDefinition {
  /** @format int32 */
  id?: number;
  displayName?: string;
  type?: Object;
}

export type Object = object;

export interface AdesaResearchRequestResearchTradeRequestResearchRequestMileageRange {
  /** @format int32 */
  start?: number;
  /** @format int32 */
  end?: number;
  /** @format int32 */
  odometerType?: number;
}

export interface AdesaResearchRequestResearchTradeRequestResearchRequestTransmission {
  /** @format int32 */
  id?: number;
  displayName?: string;
  type?: string;
}

export interface KeyValuePair {
  /** @format int32 */
  key?: number;
  value?: string;
}

export interface AdesaResearchRequestResearchTradeRequestTradeListPagination {
  pagination?: AdesaResearchRequestResearchTradeRequestTradeListPaginationListPagination;
  /** @format int32 */
  sortMethod?: number | null;
  /** @format int32 */
  sortOrder?: number | null;
}

export interface AdesaResearchRequestResearchTradeRequestTradeListPaginationListPagination {
  /** @format int32 */
  offset?: number | null;
  /** @format int32 */
  max?: number | null;
}

/** The Research trade Request that includes  */
export interface AdesaResearchRequest {
  request?: AdesaResearchRequestResearchTradeRequest;
}

/** The Research trade Request that includes  */
export interface ResearchMetadata {
  inputListDefinitions?: object[];
}

export interface ResearchMetadataRequestMetadataRequest {
  /** @format int32 */
  makeId?: number | null;
  /** @format int32 */
  modelId?: number | null;
  /** @format int32 */
  source?: number;
}

/** The Research trade Request that includes  */
export interface ResearchMetadataRequest {
  request?: ResearchMetadataRequestMetadataRequest;
}

/** The disclosure category type enum. */
export type DisclosureCategoryType =
  | 'SAFETY'
  | 'MECHANICAL'
  | 'EXTERIOR'
  | 'INTERIOR'
  | 'BRANDED_STATUSED'
  | 'TITLE'
  | 'FLEET'
  | 'DAMAGE_OTHER_HISTORY'
  | 'DRIVE_AWAY'
  | 'OVERSIZED';

/** Types of disclosure */
export type DisclosureType = 'CONDITION' | 'TRANSPORT' | 'VEHICLEHISTORY' | 'ALL';

/** The object that represents a single disclosure. */
export interface Disclosure {
  /** Label translated to be shown on the front-end */
  label: string;
  /** The disclosure category type enum. */
  category: DisclosureCategoryType;
  /** Types of disclosure */
  disclosureType?: DisclosureType;
  /** Boolean representing if the field is selected or not */
  valid: boolean;
  /** Who found the disclosure example: Autocheck or inspector */
  source?: string | null;
}

/** The disclosure type information. */
export interface DisclosureCategory {
  /** The label translated for the category type */
  label?: string;
}

/** Media for disclosure */
export interface DisclosureMedia {
  /**
   * The id of the media
   * @format int64
   */
  mediaId: number;
  /** Label translated to be shown on the front-end. */
  label: string;
  /** The link of the media. */
  url: string;
  /** The disclosure category type enum. */
  category: DisclosureCategoryType;
  /** Types of disclosure */
  disclosureType: DisclosureType;
}

/** The response object holding the list of disclosures and categories information. */
export interface DisclosureResponse {
  /** The list of disclosures */
  disclosures: Disclosure[];
  /** The map of translations based on the enum type */
  categories: Record<string, DisclosureCategory>;
  /**
   * The list of media
   * @default "Empty list"
   */
  media: DisclosureMedia[];
}

/**
 * ChatMessage
 * Contains individual chat message details.
 */
export interface ChatMessageResponse {
  /**
   * ID of the message. Useful for creating the response.
   * @format int64
   */
  id: number;
  /** The content of the chat message. */
  content: string;
  /**
   * The User ID of the user who created this message.
   * @format int64
   */
  userId: number;
  /** The display name of the user who created this message. */
  userDisplayName: string;
  /**
   * The date when the chat message was created.
   * @format date-time
   */
  dateCreated: string;
  /** Indicates whether the message is public or not. */
  open: boolean;
  /** Indicates whether the message has been ignored by the seller. */
  ignored: boolean;
}

/**
 * ChatList
 * Contains all of the chat messages related to the trade.
 */
export interface ChatListResponse {
  /** An array of ChatMessage objects. */
  chatMessages: ChatMessageResponse[];
}

/** Contains the open and pending chat counts for an Auction. */
export interface ChatCountResponse {
  /**
   * The number of public chats on the Auction.
   * @format int32
   */
  openCount: number;
  /**
   * The number of chats awaiting response.
   * @format int32
   */
  pendingCount: number;
}

/** A request to create a chat message for an auction. */
export interface ChatCreateRequest {
  /**
   * Content of the chat message being created.
   * @minLength 2
   * @maxLength 1000
   */
  content: string;
  /** Indicates if the message is public or not. */
  open: boolean;
}

export type Void = object;

export type RetailMediaMediaType = 'IMAGE' | 'DAMAGE' | 'VIDEO';

/** Media associated with the Retail VDP */
export interface RetailMedia {
  /** @format int64 */
  id: number;
  label: string;
  url: string;
  mediaType: RetailMediaMediaType;
  previewUrl?: string | null;
}

/** Trade details associated with a Retail VDP */
export interface RetailTradeDto {
  /**
   * Year of the vehicle
   * @format int64
   */
  year: number;
  /** Make of the vehicle */
  make: string;
  /** Model name of the vehicle */
  model: string;
  /** Trim of the vehicle */
  trim: string;
  /** Odometer display of the vehicle */
  odometerDisplay: string;
  /** Transmission type of the vehicle */
  transmission: string;
  /** Engine type of the vehicle */
  engine: string;
  /** Drive train of the vehicle */
  driveTrain: string;
  /** Fuel type of the vehicle */
  fuelType: string;
  /**
   * Number of seats in the vehicle
   * @format int32
   */
  seats: number;
  /** Exterior/Interior color of the vehicle */
  extIntColor: string;
  /** Vehicle history report link associated with the vehicle */
  vehicleHistoryReportUrl: string;
  /** VIN associated with the vehicle */
  vin: string;
  /** TradeRev captured vehicle options comma-separated */
  vehicleOptions: string;
}

/** Dealer generating the Retail VDP */
export interface RetailDealer {
  displayName: string;
  street?: string | null;
  city?: string | null;
  province?: string | null;
  zip?: string | null;
}

/** Vehicle feature category type enum. */
export type RetailCategoryType = 'CONVENIENCE' | 'EXTERIOR' | 'INTERIOR' | 'SAFETY' | 'MECHANICAL' | 'ENTERTAINMENT';

/** The object that represents a single retail vehicle feature */
export interface RetailVehicleFeature {
  /** Label of the vehicle feature */
  label: string;
  /** Vehicle feature category type enum. */
  category: RetailCategoryType;
}

/**
 * RetailVehicleMileage
 * Mileage data associated with the retail trade
 */
export interface RetailVehicleMileage {
  city?: string | null;
  highway?: string | null;
}

/**
 * RetailTradeMetadata
 * Retail metadata associated with a trade which are entered by the dealer during customization
 */
export interface RetailTradeMetadata {
  /**
   * Indicated Price associated with the Trade
   * @format int64
   */
  customerPrice?: number | null;
  /** Customer friendly description of the vehicle to the listing */
  notes?: string | null;
  /** Sales person name */
  salePersonName?: string | null;
  /** Sale person's email */
  salePersonEmail?: string | null;
  /** Sale person's phone number */
  salePersonPhone?: string | null;
  /** Link to dealership’s inventory */
  dealershipLink?: string | null;
}

/**
 * RetailResponse
 * Retail data associated with a trade
 */
export interface RetailResponse {
  /** GUID associated with the Retail VDP */
  guid: string;
  /** The list of media */
  media: RetailMedia[];
  /** Trade details associated with a Retail VDP */
  tradeDetails: RetailTradeDto;
  /** Dealer generating the Retail VDP */
  dealer: RetailDealer;
  /** The features associated with the VIN & trim of the Retail VDP */
  features?: RetailVehicleFeature[];
  /** Mileage data associated with the retail trade */
  mileage?: RetailVehicleMileage;
  /** Retail metadata associated with a trade which are entered by the dealer during customization */
  retailTradeMetadata?: RetailTradeMetadata;
  /** Token to generate TIAH link with the dealer */
  tiahToken?: string | null;
}

/** A request to create a retail trade */
export interface RetailCreateRequest {
  /** The list of media */
  media: RetailMedia[];
  /** Trade details associated with a Retail VDP */
  tradeDetails: RetailTradeDto;
  /** Retail metadata associated with a trade which are entered by the dealer during customization */
  retailTradeMetadata?: RetailTradeMetadata;
  /** Option to blur background for images or not */
  blurBackground?: boolean | null;
  /** Option to mute videos */
  muteVideo?: boolean | null;
  /** Can the dealer sell on TradeRev */
  canSell?: boolean | null;
}

export interface UpdateDefaultPaymentMethodRequest {
  /** @format int64 */
  paymentMethodId?: number;
  /** @format int64 */
  financeAccountId?: number;
  user?: UpdateDefaultPaymentMethodRequestUser;
}

export interface UpdateDefaultPaymentMethodRequestUser {
  /** @format int64 */
  id?: number;
  type?: UserType;
  /** @format int64 */
  companyId?: number;
  region?: Country;
}

export type UserType = 'DEALER_USER' | 'UNIVERSAL_USER';

export interface Country {
  code?: string;
}

export interface CarFaxDisclosure {
  /** Name of the disclosure */
  name?: string;
  /** Date of the disclosure in the report */
  date?: string | null;
  /**
   * Amount of the disclosure in the report
   * @format double
   */
  amount?: number | null;
  /** Additional comment around disclosure */
  comments?: string | null;
}

export interface CarFaxAdditionalProperties {
  /** Trade ID */
  tradeId?: string | null;
  /** Province of the Dealer */
  dealerProvince?: string | null;
  lienAvailable?: boolean | null;
  /** Is Lien Available */
  isLienAvailable?: boolean | null;
}

export interface CarFaxError {
  /** ID of the error */
  id?: string;
  /** Description of the error */
  message?: string | null;
}

/** CarFax disclosure request from the Enterprise CarFax Service */
export interface CarFaxDisclosuresRequest {
  /** VIN Number of the vehicle */
  vin: string;
  /** Make of the vehicle */
  make?: string | null;
  /** Model of the vehicle */
  model?: string | null;
  /** Year of the vehicle */
  year?: string | null;
  /** Callback  */
  callback?: string | null;
  /** Disclosures in the CarFax report */
  disclosures?: CarFaxDisclosure[] | null;
  /** CarFax report URL */
  report?: string | null;
  /** CarFax report status */
  status: string;
  additionalProperties?: CarFaxAdditionalProperties;
  /** CarFax report type */
  reportType?: string | null;
  /** CarFax errors */
  errors?: CarFaxError[] | null;
}

export interface OktaOneTimeVerificationResponse {
  verification?: string;
}

export interface OktaWebHookSyncUserRequest {
  eventId?: string;
  data?: OktaWebHookSyncUserRequestData;
}

export interface OktaWebHookSyncUserRequestData {
  events?: object[];
}

/** Purchase event type enum */
export type PurchaseEventPurchaseEventType =
  | 'CheckoutRequestEvent'
  | 'ManualCheckoutRequestEvent'
  | 'ErrorEvent'
  | 'TestEvent';

/** Tax info for fees */
export interface Tax {
  /**
   * Tax amount in cents
   * @format int32
   */
  amount: number;
  /** Kind of tax */
  name?: string | null;
  /** BU id of tax type */
  sourceSystemId?: string | null;
}

/** Payment method event type enum */
export type PaymentMethodPaymentMethodEventType = 'EcsPaymentMethod' | 'ExplicitPaymentMethod';

/** Payment method type enum */
export type PaymentMethodPaymentMethodType = 'ACH' | 'CREDIT_CARD' | 'FLOOR_PLAN' | 'CHEQUE' | 'WIRE' | 'OFFLINE';

/** Floorplan type enum */
export type PaymentMethodFloorPlanType = 'AFC_CORP_ADESA' | 'NEXT_GEAR_CAPITAL' | 'WESTLAKE_FLOORING_SERVICES' | 'ALLY';

/** Payment method fee */
export interface PaymentMethodFee {
  /**
   * Payment method fee amount in cents
   * @format int32
   */
  amount: number;
  /** Payment method description */
  description?: string | null;
  /** List of taxes applied */
  taxes?: Tax[];
  /**
   * Total amount of payment method fee in cents
   * @format int32
   */
  totalAmount: number;
}

/** Payment method info */
export interface PaymentMethod {
  /** Payment method event type enum */
  type?: PaymentMethodPaymentMethodEventType;
  /** Payment method description */
  description: string;
  /** Payment method type enum */
  paymentMethodType: PaymentMethodPaymentMethodType;
  /** ECS Payment method id */
  id?: string | null;
  /** Floorplan type enum */
  floorPlanEnum?: PaymentMethodFloorPlanType;
  /** Payment method fees */
  fees?: PaymentMethodFee[];
  /** Last 4 of account number */
  last4?: string | null;
  /** BU payment method id */
  sourceSystemId?: string | null;
  /** Payment method extra data */
  data?: Record<string, any>;
}

/** Line items to be included in the checkout */
export interface PayForLineItem {
  /** BU id of line item */
  lineItemId: string;
  /**
   * Amount of line item in cents
   * @format int32
   */
  amount: number;
  /**
   * Total amount of line item in cents
   * @format int32
   */
  totalAmount: number;
  /** List of taxes applied */
  taxes: Tax[];
  /** Payment method info */
  paymentMethod: PaymentMethod;
}

/** Transport option event type enum */
export type TransportOptionTransportOptionEventType =
  | 'BuyerArrangedTransport'
  | 'CarsArriveTransport'
  | 'SellerArrangedTransport';

/** Transport Option Type */
export interface TransportOption {
  /** Transport option event type enum */
  type?: TransportOptionTransportOptionEventType;
}

/** Country enum */
export type LocationCountry = 'US' | 'CA';

/** Metadata that holds location information */
export interface Location {
  /** BU address id */
  sourceSystemId?: string | null;
  /** Location name */
  name?: string | null;
  /** Location address line */
  addressLine?: string | null;
  /** Location address line 2 */
  addressLine2?: string | null;
  /** Location city */
  city?: string | null;
  /** Country enum */
  country: LocationCountry;
  /** Location state or province */
  stateProvince: string;
  /** Location postal code */
  postalCode?: string | null;
  /** Location phone */
  phone?: string | null;
}

/** Transportation incentive data */
export interface Incentive {
  /** Incentive id */
  incentiveId?: string | null;
  /**
   * Incentive amount
   * @format int32
   */
  amount: number;
  /** Incentive name */
  name: string;
}

/** Transportation quote details */
export interface TransportQuoteInfo {
  /** Transport quote id */
  quoteId: string;
  /** Transport name */
  name: string;
  /**
   * Transport distance
   * @format int32
   */
  distance: number;
  /** Transport distance unit */
  distanceUnit: string;
  /**
   * Transport price
   * @format int32
   */
  price: number;
  /** List of taxes applied */
  taxes?: Tax[];
  /** Transport currency */
  currency: string;
  /** Transport quote expires date, e.g. 2021-07-23T03:31:25.9968339+00:00 */
  expiresAt: string;
  /** Transportation incentive data */
  incentive?: Incentive;
  /**
   * Transport min days
   * @format int32
   */
  minDays?: number | null;
  /**
   * Transport max days
   * @format int32
   */
  maxDays?: number | null;
  /** Transport move type */
  moveType?: string | null;
}

/** Transport Checkout Request */
export interface TransportCheckoutRequest {
  /** Transport Option Type */
  transportOption: TransportOption;
  /** Transport quote id */
  quoteId?: string | null;
  /** Metadata that holds location information */
  dropOffAddress: Location;
  /**
   * Transport amount in cents
   * @format int32
   */
  amount: number;
  /** List of taxes applied */
  taxes?: Tax[] | null;
  /**
   * Total amount of transport in cents
   * @format int32
   */
  totalAmount: number;
  /** Payment method info */
  paymentMethod?: PaymentMethod;
  /** Transportation quote details */
  transportQuoteInfo?: TransportQuoteInfo;
}

/** Transport Option Type */
export interface AssuranceCheckoutRequest {
  /**
   * Assurance amount in cents
   * @format int32
   */
  amount?: number;
  /** List of taxes applied */
  taxes?: Tax[];
  /**
   * Total amount of assurance in cents
   * @format int32
   */
  totalAmount?: number;
  /** Payment method info */
  paymentMethod?: PaymentMethod;
}

/** Checkout request metadata */
export interface CheckoutRequest {
  /** List of line items to pay */
  payForLineItems: PayForLineItem[];
  /** List of payment method fees that apply to the checkout */
  paymentMethodFees?: PaymentMethodFee[];
  /** Transport Checkout Request */
  transportCheckoutRequest?: TransportCheckoutRequest;
  /** Transport Option Type */
  assuranceCheckoutRequest?: AssuranceCheckoutRequest;
  /**
   * Checkout request total amount in cents
   * @format int32
   */
  totalAmount?: number;
  autoCheckout?: boolean;
  /** True if requested by autocheckout */
  isAutoCheckout?: boolean;
}

export type ErrorEventErrorEventType = 'GenericError' | 'TransportOrderError' | 'TransportQuoteError';

/** Purchase Event error event */
export interface ErrorEvent {
  type?: ErrorEventErrorEventType;
  /** Error message */
  errorMessage: string;
  /** Transport quote id */
  quoteId?: string | null;
  /** Metadata that holds location information */
  origin?: Location;
  /** Metadata that holds location information */
  destination?: Location;
  /** Quote error message */
  quoteErrorResponse?: string | null;
}

/** Purchase event data */
export interface PurchaseEvent {
  /** Purchase event type enum */
  type?: PurchaseEventPurchaseEventType;
  /** Id */
  id?: string | null;
  /** Checkout request metadata */
  checkoutRequest?: CheckoutRequest;
  /** Purchase Event error event */
  error?: ErrorEvent;
}

/** Purchase event request from ETR */
export interface PurchaseEventRequest {
  /** Purchase event data */
  purchaseEvent: PurchaseEvent;
  /** Source purchase id for purchase event */
  sourcePurchaseId: string;
  /** Purchase event request callback */
  callbackMetadata?: Record<string, any>;
}

/**
 * The is the correlation key between ETR and business units.
 * @example "TRADEREV_CA_99999"
 */
export interface SourcePurchaseId {
  country?: string;
  /** @format int64 */
  auctionId?: number;
}

export type DocumentType = 'BOS' | 'VRF';

export type CustomerType = 'BUYER' | 'SELLER';

export type NotificationRequestEventSource = 'ListingRequestActivity' | 'InvalidListingRequest' | 'MarketplaceActivity';

/** The KCL notification event type enum. */
export type EventType =
  | 'ListingSent'
  | 'ListingReceivedUnchanged'
  | 'ListingCreated'
  | 'ListingSubmittedToMarketplace'
  | 'InternalCrossListingException'
  | 'InvalidSellerOrganizationId'
  | 'RetrieveConditionFailed'
  | 'SellerNotAuthorizedInMarketplace'
  | 'SendToMarketplaceFailed'
  | 'ListedWithMarketplace'
  | 'PendingReleaseToAuction'
  | 'ReleasedToAuction'
  | 'AuctionCancelled'
  | 'RemovedFromAuction'
  | 'BidReceived'
  | 'BidReserveMet'
  | 'OfferReceived'
  | 'Sold'
  | 'NotSold'
  | 'SellerNotAuthorizedInMarketplaceResolved'
  | 'InvalidSellerOrganizationIdResolved';

export interface MarketplaceActivityContent {
  status?: MarketplaceActivityContentListingStatus;
  saleEvent?: MarketplaceActivityContentSaleEvent;
  saleDetails?: MarketplaceActivityContentSaleDetails;
}

export type MarketplaceActivityContentListingStatus =
  | 'Requested'
  | 'Listed'
  | 'AtAuction'
  | 'Sold'
  | 'NotSold'
  | 'Removed'
  | 'Cancelled'
  | 'Archived';

export interface MarketplaceActivityContentSaleEvent {
  /** Id of the sale event. */
  id?: string;
  /** Name/Description of the sale event. */
  name?: string;
  /**
   * Date the sale event is scheduled to take place.
   * @format date-time
   */
  scheduledDate?: string;
}

export interface MarketplaceActivityContentSaleDetails {
  /** The name of the organization who purchased the vehicle. */
  buyerOrganizationName?: string;
  /**
   * The amount the vehicle was purchased for.
   * @format double
   */
  saleAmount?: number;
  /**
   * The buyer fees charged in addition to the SaleAmount.
   * @format double
   */
  sellFee?: number | null;
}

export interface ListingReference {
  /**
   * The KCL tracking number for the vehicle
   * @format int64
   */
  listingId?: number;
  /** VIN of the vehicle */
  vin?: string;
  /**
   * External stock number for the listing
   * @format int32
   */
  externalStockNumber?: number;
  /**
   * External ID of the seller
   * @format int32
   */
  sellerExternalId?: number;
  marketplace?: ListingReferenceMarketplace;
}

export type ListingReferenceMarketplace = 'OpenLane';

/** Notification object from KCL */
export interface NotificationRequest {
  /**
   * The UTC timestamp when the notification was generated.
   * @format date-time
   */
  timestamp: string;
  source?: NotificationRequestEventSource;
  /** The KCL notification event type enum. */
  type: EventType;
  /** A description of the notification. */
  message?: string | null;
  error?: boolean;
  marketplaceActivityContent?: MarketplaceActivityContent;
  listingReference: ListingReference;
  /** Indicates if this notification was sent due to an error. */
  isError?: boolean;
}

/** The object that represents a single badge. */
export interface BadgeResponse {
  /**
   * Id of the badge
   * @format int64
   */
  id: number;
  /** Type of the Badge */
  type: string;
}

export interface TradeInVerifyResponse {
  status?: string;
}

/** A request to send a verification code to phonenumber */
export interface TradeInVerifyRequest {
  /** Phone Number */
  phoneNumber: string;
}

/**
 * Check
 * Contains response of check request
 */
export interface TradeInCheckResponse {
  /** Status of request */
  status: string;
  /** Token to access trade in at home create page */
  token?: string | null;
}

/** A request to verify 4 digit code sent by twilio */
export interface TradeInCheckRequest {
  /** Phone Number */
  phoneNumber: string;
  /** 4 digit code */
  code: string;
  /**
   * Dealer ID
   * @format int64
   */
  dealerId: number;
  /** Dealer displayName */
  dealerDisplayName: string;
}

export interface TradeInDealerLocatorResponse {
  /**
   * ID of the dealer
   * @format int64
   */
  id?: number;
  /** Display name of dealer */
  displayName?: string | null;
  /**
   * Longitude of dealer
   * @format double
   */
  longitude?: number | null;
  /**
   * Latitude of dealer
   * @format double
   */
  latitude?: number | null;
  /** City of dealer */
  city?: string;
  /** Street of dealer */
  street?: string;
  /** Zip code of dealer */
  zip?: string;
}

export interface PointType {
  /**
   * latitude value
   * @format double
   */
  latitude?: number;
  /**
   * longitude value
   * @format double
   */
  longitude?: number;
}

/** A dealer locator request to return locations of dealers in proximity to given point lat/long */
export interface TradeInDealerLocatorRequest {
  /**
   * Radius area
   * @format double
   */
  radius: number;
  point: PointType;
  franchiseDealerOnly?: boolean;
  /** specifies if the search should only include franchise dealers */
  isFranchiseDealerOnly: boolean;
}

/** Error properties from client to be used for error logging */
export interface ErrorRequest {
  /** Type of error */
  errorType?: string;
  /** UserAgent string */
  userAgent?: string | null;
  /** Error Stack trace */
  stackTrace?: string | null;
  /** Error message */
  errorMessage?: string | null;
  /** PageUrl error occurred */
  pageUrl?: string | null;
  /** Total heap size available to the client */
  jsHeapSizeTotal?: string | null;
  /** Total heap size used by the client */
  jsHeapSizeUsed?: string | null;
  /** Effective bandwidth estimate of client */
  downLink?: string | null;
  /** Effective network connection type */
  networkType?: string | null;
  /** Interior height of the client window in pixels */
  windowHeight?: string | null;
  /** Interior width of the client window in pixels */
  windowWidth?: string | null;
  /** Height of the screen in pixels */
  screenHeight?: string | null;
  /** Width of the screen in pixels */
  screenWidth?: string | null;
  /** user ID */
  userId?: string | null;
  /** dealer ID */
  dealerId?: string | null;
  /** is a CSU user */
  isCSU?: string | null;
}

export interface CustomizationMetadata {
  logo: any;
  tiah: CustomizationMetadataTiahMetadata;
  retailVdp: CustomizationMetadataRetailVdpMetadata;
}

export interface CustomizationMetadataRetailVdpMetadata {
  salesPersonName: any;
  salesPersonEmail: any;
  salesPersonPhone: any;
  dealershipWebsite: any;
}

export interface CustomizationMetadataTiahMetadata {
  heading: any;
  greeting: any;
}

/** Response to upload a dealer logo */
export interface PresignedUrlForDealerLogoResponse {
  presignedS3Uris: string;
}

/** The pagination information for the request */
export interface Pagination {
  /**
   * First item to return for pagination (default is 0).
   * @format int32
   * @min 0
   * @max 9999
   * @example 0
   */
  from: number;
  /**
   * Maximum number of items to return for pagination (default is 20).
   * @format int32
   * @min 1
   * @max 50
   * @example 20
   */
  size: number;
}

export interface SortOrder {
  /**
   * the order of the sort
   * @example "ASC"
   */
  order?: 'ASC' | 'DESC';
}

/** The trade sort - A hashmap with the sort as a key and a SortOrder as the value */
export type TradeSort =
  | 'RELEVANCE'
  | 'TRADE'
  | 'LAUNCH'
  | 'SALE_EVENT'
  | 'DATE'
  | 'DEALER'
  | 'MILEAGE'
  | 'BUY_TRADE_STATE'
  | 'SELL_TRADE_STATE'
  | 'YEAR'
  | 'ACTIVE_TIMER';

/** The request for filtering and/or searching traderev trades. */
export interface SearchRequest {
  /**
   * The search term you want to search for
   * @example "2019 Toyota Corolla black"
   */
  search?: string;
  /**
   * Trade state to filter the search result
   * @example 1
   */
  tradeState?: number;
  /** The pagination information for the request */
  pagination?: Pagination;
  /**
   * Specifies how the results must be sorted.
   * @example [{"RELEVANCE":{"order":"DESC"}},{"TRADE":{"order":"ASC"}}]
   */
  sort?: TradeSort[];
}

/** Contains a list of trades that match the criteria */
export interface SearchResult {
  /**
   * ID of a trade in the list
   * @example 10000735
   */
  tradeId: number;
  /**
   * ID of a trade auction for Active trades. The value is 'Null' for Upcoming and Buy now trades
   * @example 558489
   */
  auctionId?: number;
  /**
   * The VIN of the vehicle
   * @example "1ZVBP8AM7E5234213"
   */
  vin?: string;
  /**
   * The year of the vehicle
   * @example 2014
   */
  year?: number;
  make?: {
    /**
     * the name of the make
     * @example "Toyota"
     */
    name?: string;
    /**
     * the id of the make
     * @example 14
     */
    id?: number;
  };
  model?: {
    /**
     * The model name of the vehicle
     * @example "Corolla"
     */
    name?: string;
  };
  /**
   * The trim of the vehicle
   * @example "2dr Cpe V6"
   */
  trim?: string;
  /**
   * The mileage of the vehicle
   * @example 3000
   */
  mileage?: number;
  /**
   * The date when the trade launched from Upcoming to Active. 'Null' for Active and Buy now trades
   * @format date
   * @example "2020-06-29T04:00:00Z"
   */
  dateAutoLaunch?: string;
  tradeState?: {
    /**
     * the trades state:
     *  * `0` - Parked state
     *  * `1` - Active state
     *  * `2` - Lost state
     *  * `3` - Arrived state
     *  * `4` - Won state
     *  * `5` - Delivered state
     *  * `6` - Closing state
     *  * `7` - Pending state
     *  * `10` - Upcoming state
     *  * `11` - Buy Now state
     */
    id?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 10 | 11;
  };
  transmission?: {
    /**
     * The transmission of the vehicle (0 = Automatic, 1 = Manual, 2 = Semi-Auto)
     * @example 0
     */
    id?: 0 | 1 | 2;
  };
  /**
   * the type of odometer unit, (0 = KM, 1 = MI)
   * @example 0
   */
  odometerType?: 0 | 1;
  /**
   * The fuel type of the vehicle:
   *   * `0` - Unknown
   *   * `1` - Gasoline
   *   * `2` - Diesel
   *   * `3` - Flex Fuel
   *   * `4` - Hybrid
   *   * `5` - Electric
   *   * `6` - Alternate
   * @example 1
   */
  fuel?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  /**
   * If the vehicle is sold as is
   * @example false
   */
  asIs?: boolean;
  /**
   * If this is a retail trade
   * @example false
   */
  retail?: boolean;
  /**
   * If the vehicle has landed at the pickup location
   * @example true
   */
  inStock?: boolean;
  /**
   * The trade stock number
   * @example "A134"
   */
  stockNumber?: string;
  /**
   * If the vehicle has accidents or other issues
   * @example false
   */
  hasDisclosures?: boolean;
  /**
   * If the vehicle history report is available
   * @example true
   */
  hasReport?: boolean;
  /**
   * If there is an ongoing chat about this trade
   * @example false
   */
  hasChat?: boolean;
  /**
   * URL of the vehicle thumb nail image
   * @example "https://dciz2bbrdh6r7.cloudfront.net/43220-15378023022381_t.jpg"
   */
  thumb?: string;
  dealer?: {
    /**
     * Identifier of the dealership
     * @example 1337
     */
    id?: number;
    /**
     * name of the dealership
     * @example "Test Dealership"
     */
    name?: string;
    /**
     * rating of the dealership
     * @example 2.67
     */
    rating?: number;
  };
  topBid?: {
    /**
     * Number of bids so far
     * @example 5
     */
    count?: number;
    /**
     * Current amount of the highest bid
     * @example 5
     */
    amount?: number;
    /**
     * If the current user is the top bidder
     * @example false
     */
    byUser?: boolean;
    /**
     * If the current user is a member of the top bidder dealership
     * @example false
     */
    byDealer?: boolean;
  };
  saleEvent?: {
    /**
     * The identifier of the sale event
     * @example 2
     */
    id?: number;
    /**
     * The name of the sale event
     * @example "Toyota Sale Event!"
     */
    name?: string;
    /**
     * The date and time the sale event is turning into active
     * @format date
     * @example "2021-03-12T05:00:00Z"
     */
    launchDate?: string;
    /**
     * The date and time the sale event ends
     * @format date
     * @example "2021-03-15T05:00:00Z"
     */
    endDate?: string;
    /**
     * The date and time the sale event is committed
     * @format date
     * @example "2021-03-11T05:00:00Z"
     */
    committedDate?: string;
    /**
     * The number of trades in this sale event
     * @example 5
     */
    tradeCount?: number;
  };
  /**
   * If the user has ever placed a bid on this trade
   * @example false
   */
  bidder?: boolean;
  /**
   * If the trade is in the user’s impound list
   * @example false
   */
  impounded?: boolean;
  /**
   * If the trade is in the user’s watchlist
   * @example false
   */
  watchlist?: boolean;
  /**
   * If the trade is recommended to this user
   * @example false
   */
  recommended?: boolean;
  /**
   * The distance bucket index (range) between the selling dealership and the user’s zip code
   * @example 1
   */
  distanceBucket?: number;
  /**
   * Date and time the trade was created. (ISO-8601)
   * @format date
   * @example "2020-06-29T17:01:03Z"
   */
  dateCreated?: string;
  /**
   * Date and time the trade was modified. (ISO-8601)
   * @format date
   * @example "2020-06-30T17:01:03Z"
   */
  dateModified?: string;
  /**
   * Date and time the trade pending state expires. (nullable, ISO-8601)
   * @format date
   * @example "2020-07-02T17:01:03Z"
   */
  datePendingExpiry?: string;
  /**
   * Date and time the trade closing state ends. (nullable, ISO-8601)
   * @format date
   * @example "2020-07-02T17:01:03Z"
   */
  dateClosing?: string;
  /**
   * Date and time the trade was marked delivered. (nullable, ISO-8601)
   * @format date
   * @example "2020-07-02T17:01:03Z"
   */
  dateDelivered?: string;
  /**
   * Date and time the vehicle will be available. (nullable, ISO-8601)
   * @format date
   * @example "2020-07-02T17:01:03Z"
   */
  dateAvailable?: string;
  /**
   * Date and time the trade was marked arrived. (nullable, ISO-8601)
   * @format date
   * @example "2020-07-02T17:01:03Z"
   */
  dateArrived?: string;
  /**
   * Date and time the vehicle was sold (won). (nullable, ISO-8601)
   * @format date
   * @example "2020-07-02T17:01:03Z"
   */
  dateAcquired?: string;
  /**
   * Date and time the auction began. (nullable, ISO-8601)
   * @format date
   * @example "2020-07-02T17:01:03Z"
   */
  dateAuctionStarted?: string;
  /**
   * Is the Trade was inspected by TradeRev
   * @example true
   */
  inspected?: boolean;
  /**
   * Is Trade would skip closing state.
   * @example false
   */
  skipClosing?: boolean;
  /**
   * Price targeted by the seller. (nullable)
   * @example 10000
   */
  targetPrice?: number;
  /**
   * The id of the seller network (nullable)
   * @example "123456"
   */
  sellingNetworkId?: string;
  count?: {
    /**
     * The total number of trades matching the criteria
     * @example 145
     */
    total?: number;
  };
  /**
   * A high threshold value from our valuation engine for the vehicle
   * @example 100000
   */
  highBidThreshold?: number;
  /**
   * A low threshold value from our valuation engine for the vehicle
   * @example 3000
   */
  minBidThreshold?: number;
  /**
   * Returns when we are calling search api if the search term was an exact match or not
   * @example true
   */
  exactMatch?: boolean;
  /**
   * Returns a count of exact matches when we are calling search api
   * @example 55
   */
  exactMatchTotal?: number;
  /**
   * Date and time for the auction to expire
   * @format date
   * @example "2020-07-02T17:01:03Z"
   */
  activeExpiryTime?: string;
  tradeFloorPrice?: {
    /**
     * If the top bid met the floor price
     * @example false
     */
    isFloorPriceMet?: boolean;
    /**
     * The floor price of the trade, only visible to the seller
     * @example 10000
     */
    valueDollars?: number;
  };
  /**
   * Start time for buy now trade
   * @format date
   * @example "2020-07-10T17:01:03Z"
   */
  lostInterimStartTime?: string;
  /**
   * engine displacement of vehicle
   * @example "6.2"
   */
  displacement?: string;
  /**
   * The exterior color of the vehicle
   * @example "Blue"
   */
  color?: string;
  /**
   * Pickup address of the vehicle province
   * @example "Ontario"
   */
  province?: string;
  /**
   * vehicle cylinders
   * @example 8
   */
  cylinders?: number;
}

export interface PaymentOnHoldResponse {
  /** @minLength 1 */
  make: string;
  /** @minLength 1 */
  model: string;
  /** @minLength 1 */
  vin: string;
  /** @format int64 */
  salePrice?: number;
  needsOwnership?: boolean;
  needsLienRelease?: boolean;
  /** @format int32 */
  year?: number | null;
  /** @format date-time */
  dateLanded?: string | null;
  uploadedDocuments?: UploadedDocumentResponse[] | null;
  vehicleImageUrl?: string | null;
  province?: string | null;
  canUploadTitle?: boolean;
}

export interface PaymentOnHoldResponsePagedResponse {
  data: PaymentOnHoldResponse[];
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int64 */
  totalResults: number;
}

export type PaymentOnHoldSearchRequest = PaymentOnHoldSortBySortPaginationQuery & {
  organizationIds: string[];
};

export type PaymentOnHoldSortBy = 'SALEPRICE' | 'PURCHASEDATE';

export interface PaymentOnHoldSortBySortPaginationQuery {
  $type: string;
  sortBy?: PaymentOnHoldSortBy;
  sortOrder?: PaymentOnHoldSortOrder;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageNumber?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  pageSize?: number;
}

export type PaymentOnHoldSortOrder = 'DESC' | 'ASC';

export interface PaymentOnHoldSummaryRequest {
  organizationIds: string[];
}

export interface PaymentOnHoldSummaryResponse {
  /** @format int32 */
  count?: number;
  /** @format int64 */
  totalSalePrice?: number;
}

export type PaymentOnHoldDocumentType = 'Title' | 'Lien';

export interface PaymentOnHoldUploadDocumentRequest {
  key?: string | null;
  documentType?: PaymentOnHoldDocumentType;
}

export interface UploadAttachmentRequest {
  /** @minLength 1 */
  fileName: string;
  /** @minLength 1 */
  contentType: string;
  /**
   * @format int64
   * @min 1
   * @max 10485760
   */
  contentLength: number;
}

export interface UploadAttachmentResponse {
  /** @minLength 1 */
  key: string;
  /** @minLength 1 */
  presignedUrl: string;
}

export interface UploadedDocumentResponse {
  filename?: string | null;
  preSignedUrl?: string | null;
  documentType?: PaymentOnHoldDocumentType;
}

export interface SortOption {
  order: 'ASC' | 'DESC';
}

export interface Bid {
  /** @format int32 */
  count: number;
  /** @format int32 */
  amount: number;
  byUser: boolean;
  byDealer: boolean;
}

export interface Count {
  /** @format int32 */
  total: number;
}

export interface Dealer {
  /** @format int32 */
  id: number;
  displayName: string;
  /** @format float */
  rating?: number;
  /** @format int32 */
  ratingCount?: number;
  dealerBadges?: number[];
  isTrdSeller?: boolean;
  isTrdExemptBuyer?: boolean;
}

export interface LegacyFields {
  /** @format int32 */
  topBidderId?: number;
  /** @format int32 */
  topBidderDealerId?: number;
  dealerGroupIds?: number[];
}

export interface Make {
  /** @format int32 */
  id: number;
  displayName: string;
}

export interface Model {
  displayName: string;
}

export interface SaleEvent {
  /** @format int32 */
  id: number;
  name?: string;
  /** @format date-time */
  launchDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  committedDate?: string;
  /** @format int32 */
  tradeCount?: number;
  isMultiRooftopEvent?: boolean;
  dgnNetworkId?: string;
}

export interface TradeFloorPrice {
  /** @format int32 */
  valueDollars?: number;
  isFloorPriceMet: boolean;
  hasFloorPrice: boolean;
  isCloseToFloorPrice: boolean;
}

export interface TradeResponse {
  /** @format int32 */
  tradeId: number;
  /** @format int32 */
  auctionId?: number;
  tradeState: TradeState;
  dealer: Dealer;
  topBid: Bid;
  thumb?: string;
  vin: string;
  /** @format int32 */
  year: number;
  make: Make;
  model: Model;
  trim?: string;
  transmission: Transmission;
  /** @format int32 */
  fuel?: number;
  /** @format int32 */
  odometerType: number;
  /** @format date-time */
  dateCreated: string;
  /** @format date-time */
  dateModified?: string;
  /** @format date-time */
  dateAcquired?: string;
  /** @format date-time */
  dateArrived?: string;
  /** @format date-time */
  dateAutoLaunch?: string;
  /** @format date-time */
  dateDelivered?: string;
  /** @format date-time */
  dateAvailable?: string;
  /** @format date-time */
  dateClosing?: string;
  /** @format date-time */
  datePendingExpiry?: string;
  /** @format date-time */
  dateAuctionStarted?: string;
  asIs: boolean;
  retail: boolean;
  inStock: boolean;
  stockNumber?: string;
  hasDisclosures: boolean;
  hasReport: boolean;
  hasChat: boolean;
  hasBid: boolean;
  /** @format int32 */
  mileage: number;
  saleEvent?: SaleEvent;
  bidder: boolean;
  watchlist: boolean;
  impounded: boolean;
  recommended: boolean;
  /** @format int32 */
  distance?: number;
  /** @format int32 */
  distanceBucket?: number;
  count: Count;
  inspected: boolean;
  isSkipClosing: boolean;
  /** @format double */
  targetPrice?: number;
  sellingNetworkId: string;
  /** @format int32 */
  minBidThreshold?: number;
  /** @format int32 */
  highBidThreshold?: number;
  exactMatch?: boolean;
  /** @format int32 */
  exactMatchTotal?: number;
  /** @format date-time */
  activeExpiryTime?: string;
  tradeFloorPrice: TradeFloorPrice;
  /** @format date-time */
  lostInterimStartTime?: string;
  displacement?: string;
  province?: string;
  color?: string;
  /** @format int32 */
  cylinders?: number;
  /** @format int32 */
  mediaCount: number;
  isAtAdesaLocation?: boolean;
  legacyFields?: LegacyFields;
}

export interface TradeState {
  /** @format int32 */
  id: number;
}

export interface Transmission {
  /** @format int32 */
  id: number;
}

export interface InputDefinition {
  /** @format int32 */
  key: number;
  value: string;
}

export interface MileageRange {
  /** @format int32 */
  start: number;
  /** @format int32 */
  end: number;
  /** @format int32 */
  odometerType: number;
}

export interface Request {
  inputDefinitions: InputDefinition[];
  /** @format int32 */
  modelYear?: number;
  /** @format int32 */
  modelYearTo?: number;
  manufacturerId: number[];
  model: string[];
  trim?: string[];
  mileageRange?: MileageRange;
}

export interface ResearchTradeRequest {
  request?: Request;
  /** The pagination information for the request */
  pagination?: Pagination;
  sort?: SortMethod;
}

export interface SortMethod {
  field: string;
  order: string;
}

export interface PendingRequest {
  /**
   * @format int32
   * @min 0
   */
  offset: number;
  /**
   * @format int32
   * @min 0
   * @default 20
   */
  size: number;
  sellingNetworkId?: string;
  hasNegotiation: boolean;
}

export interface PendingResponse {
  /**
   * Total negotiation value for the trades
   * @format int32
   */
  totalValue: number;
  /**
   * Total number of request matching the request
   * @format int32
   */
  totalResult: number;
  /**
   * Return same value as offset field in the request
   * @format int32
   */
  offset: number;
  /**
   * Return same value as size field in the request
   * @format int32
   */
  size: number;
  /** Trade matching the request, if no trade matches the request this will be an empty array */
  trades: PendingTrade[];
}

/** Trade matching the request, if no trade matches the request this will be an empty array */
export interface PendingTrade {
  /** @format int32 */
  id: number;
  /** @format int32 */
  associatedTradeId?: number;
  /** @format int32 */
  auctionId?: number;
  /** @format int32 */
  tradeState: number;
  sellingNetworkId?: string;
  vin: string;
  /** @format int32 */
  year: number;
  make: Make;
  model: Model;
  trim?: string;
  transmission: Transmission;
  /** @format int32 */
  mileage: number;
  /** @format int32 */
  odometerType: number;
  thumb?: string;
  dealer: Dealer;
  /** @format int32 */
  topBid?: number;
  /** @format int32 */
  floorPrice?: number;
  asIs: boolean;
  hasDisclosures: boolean;
  inStock: boolean;
  /** NegotiationState: `buyer_offer` - Only one offer initiated by buyer `buyer_counter` - Counter offer by buyer `buyer_firm` - Buyer stat firm `seller_offer` - Only one offer initiated by seller `seller_counter` - Counter offer by seller `final_asking_price` - Offer sent to second bidder `declined` - Offer declined or Trade expired `no_negotiation` - No negotiation created `accepted` - Offer accepted  */
  negotiationState?: NegotiationState;
  /**
   * Latest negotiation offer
   * @format int32
   */
  negotiationOffer?: number;
  /** @format date-time */
  datePendingExpiry?: string;
  /** If Send to Closing button should be visible */
  sellerNegotiated: boolean;
  isInternalTrade: boolean;
  isGreyOut: boolean;
  hasChat: boolean;
}

export interface TradeFilter {
  /**
   * @format int32
   * @min 0
   * @max 10000
   */
  minYear?: number;
  /**
   * @format int32
   * @min 0
   * @max 999999
   */
  maxYear?: number;
  /**
   * @format int32
   * @min 0
   * @max 200000
   */
  minMileage?: number;
  /**
   * @format int32
   * @min 0
   * @max 200000
   */
  maxMileage?: number;
  /** @format int32 */
  saleEventId?: number;
  makeModels: Record<string, string[]>;
  makeTrims: Record<string, string[]>;
  /** @uniqueItems true */
  locations: string[];
  /** @uniqueItems true */
  includeActions: ('IMPOUNDED' | 'BIDDER' | 'WATCHLIST' | 'RECOMMENDED' | 'CHAT')[];
  /** @uniqueItems true */
  excludeActions: ('IMPOUNDED' | 'BIDDER' | 'WATCHLIST' | 'RECOMMENDED' | 'CHAT')[];
  /** @uniqueItems true */
  transmission: number[];
  /** @uniqueItems true */
  fuel: number[];
  asIs?: boolean;
  inStock?: boolean;
  floorPriceMet?: boolean;
  accident?: boolean;
  accidentOverLimit?: boolean;
  independent?: boolean;
  arrivedStatus?: 'AWAITING_CHECKOUT' | 'PAYMENT_REQUESTED' | 'PAYMENT_APPROVED' | 'LATE_PICKUP';
  /** @format int32 */
  sellingNetworkId?: number;
  /** @uniqueItems true */
  exteriorColor: string[];
  /** @uniqueItems true */
  structuralCondition: string[];
  /** @uniqueItems true */
  engineType: number[];
  /** @uniqueItems true */
  drivetrainType: string[];
  /** @uniqueItems true */
  trims: string[];
  /**
   * @format int32
   * @min -1
   * @max 20
   */
  distanceBucket: number;
  /**
   * @minLength 5
   * @maxLength 10
   */
  zipCode?: string;
}

export interface TradeListRequest {
  filter: TradeFilter;
  /** The pagination information for the request */
  pagination: Pagination;
  sort: Record<string, SortOption>[];
  /** @format int32 */
  customSort?: number;
  /** @format int32 */
  saleEventId?: number;
  enableLegacyFields: boolean;
}

export interface AvailableGraph {
  /** @format int32 */
  id: number;
  title: string;
}

export interface Fuel {
  /** @format int32 */
  fuelId: number;
}

export interface SortMethods {
  name: string;
  /** @format int32 */
  sortMethod: number;
}

export interface PostSaleTradeListRequest {
  /** provides filter parameter for trade list with payments on hold */
  dataFilter?: PostSaleTradeListRequestDataFilter;
  /** provides sort parameter for trade list with payments on hold */
  sort?: PostSaleTradeListRequestSort;
  /** provides data for pagination */
  pagination?: PostSaleTradeListRequestPagination;
}

/** provides filter parameter for trade list with payments on hold */
export interface PostSaleTradeListRequestDataFilter {
  /** the key of the filter being used */
  id?: number;
}

/** provides sort parameter for trade list with payments on hold */
export interface PostSaleTradeListRequestSort {
  /** the key of the sorting being used */
  id?: number;
}

/** provides data for pagination */
export interface PostSaleTradeListRequestPagination {
  /** offset */
  from?: number;
  /** limit trade list array length */
  size?: number;
}

export interface PostSaleTradeListResponse {
  tradesWithPaymentsOnHold?: PostSaleTradeListResponseTrade[];
}

export interface PostSaleTradeListResponseTrade {
  /** provides ownership status */
  titleStatus?: number;
  /** provides lien release status */
  lienStatus?: number;
  /** provides address where the ownership title can be send to */
  titleMailToAddress?: string;
  /** provides email address where the lien release can be send to */
  lienEmailToAddress?: string;
  /** trade details */
  tradeResponse?: object;
}

export namespace User {
  /**
   * No description
   * @tags user
   * @name List
   * @summary Return all user preferences.
   * @request GET:/user/preferences
   */
  export namespace List {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags user
   * @name Update
   * @summary Update user preferences.
   * @request PUT:/user/preferences
   */
  export namespace Update {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UserPreferenceRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Research {
  /**
   * No description
   * @tags research
   * @name List
   * @summary Handles the trade research request for Adesa Market Guide
   * @request POST:/research/trade/list
   */
  export namespace List {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AdesaResearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags research
   * @name Metadata
   * @summary Returns AMG metadata required to perform research requests
   * @request POST:/research/metadata
   */
  export namespace Metadata {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResearchMetadataRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Disclosure {
  /**
   * No description
   * @tags disclosure
   * @name ListDisclosures
   * @summary Returns a list of all the Disclosure data related to the type (Conditiion, Vehicle History) for a specified trade.
   * @request GET:/disclosure/{type}/trade/{tradeId}
   */
  export namespace ListDisclosures {
    export type RequestParams = {
      /** Types of disclosure */
      type: DisclosureType;
      /** @format int32 */
      tradeId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Chat {
  /**
   * No description
   * @tags chat
   * @name List
   * @summary Return the list of chat messages of an auction.
   * @request GET:/chat/auction/{auctionId}
   */
  export namespace List {
    export type RequestParams = {
      /** @format int64 */
      auctionId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags chat
   * @name Create
   * @summary Create a chat message for an existing auction.
   * @request POST:/chat/auction/{auctionId}
   */
  export namespace Create {
    export type RequestParams = {
      /** @format int64 */
      auctionId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = ChatCreateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags chat
   * @name Count
   * @summary Return the public and pending chat message counts for an auction.
   * @request GET:/chat/auction/{auctionId}/count
   */
  export namespace Count {
    export type RequestParams = {
      /** @format int64 */
      auctionId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags chat
   * @name Reply
   * @summary Create a reply to an existing message.
   * @request POST:/chat/{chatMessageId}/reply
   */
  export namespace Reply {
    export type RequestParams = {
      /** @format int64 */
      chatMessageId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = ChatCreateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags chat
   * @name Ignore
   * @summary Mark the chat message as ignored by the user.
   * @request PUT:/chat/{chatMessageId}/ignore
   */
  export namespace Ignore {
    export type RequestParams = {
      /** @format int64 */
      chatMessageId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Retail {
  /**
   * No description
   * @tags retail
   * @name Create
   * @summary Create a retail trade equivalent for an existing trade.
   * @request POST:/retail/trade/{tradeId}
   */
  export namespace Create {
    export type RequestParams = {
      /** @format int64 */
      tradeId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = RetailCreateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags retail
   * @name FetchRetailTrade
   * @summary Return the retail trade given a retail guid
   * @request GET:/retail/token/{guid}
   */
  export namespace FetchRetailTrade {
    export type RequestParams = {
      guid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Dealer {
  /**
   * No description
   * @tags dealer
   * @name UpdateDefaultPaymentMethod
   * @summary Update Dealer's default-payment-method
   * @request PUT:/dealer/payment/default
   */
  export namespace UpdateDefaultPaymentMethod {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateDefaultPaymentMethodRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @name GetPresignedUrls
   * @request GET:/dealer/settings/generate-presigned-urls
   */
  export namespace GetPresignedUrls {
    export type RequestParams = {};
    export type RequestQuery = {
      fileType?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PresignedUrlForDealerLogoResponse;
  }
}

export namespace Settings {
  /**
   * No description
   * @tags dealer
   * @name GetCustomizationMetadata
   * @summary Get customization settings on Retail Tools
   * @request GET:/settings/customization/metadata
   */
  export namespace GetCustomizationMetadata {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomizationMetadata;
  }
  /**
   * No description
   * @name GetDealerRetailInfo
   * @summary Get Dealer Retail settings
   * @request GET:/settings/customization
   */
  export namespace GetDealerRetailInfo {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags dealer
   * @name UpdateDealerRetailInfo
   * @summary Update Dealer retail settings
   * @request PUT:/settings/customization
   */
  export namespace UpdateDealerRetailInfo {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = any;
    export type RequestHeaders = {};
    export type ResponseBody = Object;
  }
  /**
   * No description
   * @tags autowin
   * @name GetAutoWinSetting
   * @summary Returns the autowin setting of dealer
   * @request GET:/settings/autowin
   */
  export namespace GetAutoWinSetting {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags autowin
   * @name UpdateAutoWinSetting
   * @summary Updates the autowin setting of dealer
   * @request PATCH:/settings/autowin
   */
  export namespace UpdateAutoWinSetting {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AutoWinSettingUpdateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Carfax {
  /**
   * No description
   * @tags carfax
   * @name ReceiveCarFaxHistoryReport
   * @summary Receive CarFax vehicle history disclosures
   * @request POST:/carfax/history-report
   */
  export namespace ReceiveCarFaxHistoryReport {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CarFaxDisclosuresRequest;
    export type RequestHeaders = {
      'authentication-token': string;
    };
    export type ResponseBody = any;
  }
}

export namespace Okta {
  /**
   * No description
   * @tags okta
   * @name OneTimeVerification
   * @summary OKTA one time verification
   * @request GET:/okta/sync-user-profile
   */
  export namespace OneTimeVerification {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      'authentication-token': string;
      'X-Okta-Verification-Challenge': string;
    };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags okta
   * @name SyncUserProfile
   * @summary Sync user profile
   * @request POST:/okta/sync-user-profile
   */
  export namespace SyncUserProfile {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = OktaWebHookSyncUserRequest;
    export type RequestHeaders = {
      'authentication-token': string;
    };
    export type ResponseBody = any;
  }
}

export namespace Api {
  /**
   * No description
   * @tags enterprisecheckout
   * @name PurchaseEventsReceive
   * @summary Purchase Event Receive
   * @request POST:/api/v4/PurchaseEvents/Receive
   */
  export namespace PurchaseEventsReceive {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PurchaseEventRequest;
    export type RequestHeaders = {
      Authorization: string;
    };
    export type ResponseBody = any;
  }
  /**
   * @description Called by the UI from Payment on Hold Page. OrganizationIds must be specified otherwise no results will be returned. Default sort order is purchase date descending
   * @tags PaymentOnHold
   * @name PaymentOnHoldSearchList
   * @summary List purchases which are in payment hold status
   * @request POST:/api/v4/PaymentOnHold/search
   * @secure
   */
  export namespace PaymentOnHoldSearchList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PaymentOnHoldSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PaymentOnHoldResponsePagedResponse;
  }
  /**
   * @description Called by the UI from Payment on Hold Page. OrganizationIds must be specified otherwise no results will be returned. Default sort order is purchase date descending
   * @tags PaymentOnHold
   * @name PaymentOnHoldList
   * @summary List purchases which are in payment hold status
   * @request POST:/api/v4/PaymentOnHold
   * @secure
   */
  export namespace PaymentOnHoldList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PaymentOnHoldSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PaymentOnHoldResponsePagedResponse;
  }
  /**
   * No description
   * @tags PaymentOnHold
   * @name PaymentOnHoldSummaryList
   * @summary Get summary of PaymentOnHold purchases by organization ids
   * @request POST:/api/v4/PaymentOnHold/summary
   * @secure
   */
  export namespace PaymentOnHoldSummaryList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PaymentOnHoldSummaryRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PaymentOnHoldSummaryResponse;
  }
  /**
   * No description
   * @tags PaymentOnHold
   * @name PostPaymentOnHoldPurchaseIdDocumentUploadTokens
   * @summary Obtain a pre-signed URL to upload a document
   * @request POST:/api/v4/PaymentOnHold/{purchaseId}/DocumentUploadTokens
   * @secure
   */
  export namespace PostPaymentOnHoldPurchaseIdDocumentUploadTokens {
    export type RequestParams = {
      purchaseId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UploadAttachmentRequest;
    export type RequestHeaders = {};
    export type ResponseBody = UploadAttachmentResponse;
  }
  /**
   * No description
   * @tags PaymentOnHold
   * @name PostPaymentOnHoldPurchaseIdDocuments
   * @summary Upload a document to SF
   * @request POST:/api/v4/PaymentOnHold/{purchaseId}/Documents
   * @secure
   */
  export namespace PostPaymentOnHoldPurchaseIdDocuments {
    export type RequestParams = {
      purchaseId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PaymentOnHoldUploadDocumentRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Enterprisecheckout {
  /**
   * No description
   * @tags enterprisecheckout
   * @name HandleGetDocuments
   * @summary Fetch Vehicle Documents (BOS, VRF)
   * @request GET:/enterprisecheckout/documents/{documentType}/{customerType}/{sourcePurchaseId}
   */
  export namespace HandleGetDocuments {
    export type RequestParams = {
      /** The is the correlation key between ETR and business units. */
      sourcePurchaseId: SourcePurchaseId;
      documentType: DocumentType;
      customerType: CustomerType;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      Authorization: string;
    };
    export type ResponseBody = any;
  }
}

export namespace Kcl {
  /**
   * No description
   * @tags kcl
   * @name RetrieveEvent
   * @summary Webhook to retrieve listing event notifications from KCL
   * @request POST:/kcl/event/listing/{listingID}
   */
  export namespace RetrieveEvent {
    export type RequestParams = {
      /** @format int64 */
      listingId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = NotificationRequest;
    export type RequestHeaders = {
      'authentication-token': string;
    };
    export type ResponseBody = any;
  }
}

export namespace Dealers {
  /**
   * No description
   * @tags badge
   * @name GetBadges
   * @summary Get the list of badges based on a dealer Id.
   * @request GET:/dealers/{dealerId}/badges
   */
  export namespace GetBadges {
    export type RequestParams = {
      /** @format int32 */
      dealerId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Tradein {
  /**
   * No description
   * @tags tradein
   * @name Verify
   * @summary Verify phone number
   * @request POST:/tradein/verify
   */
  export namespace Verify {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TradeInVerifyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags tradein
   * @name Check
   * @summary Verify twilio code
   * @request POST:/tradein/check
   */
  export namespace Check {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TradeInCheckRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags tradein
   * @name DealerLocator
   * @summary Returns the list of dealer close to the specified location lat/long
   * @request POST:/tradein/dealer-locator
   */
  export namespace DealerLocator {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TradeInDealerLocatorRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Instrumentation {
  /**
   * No description
   * @tags instrumentation
   * @name SendError
   * @summary Report an error that occured on a client application
   * @request POST:/instrumentation/senderror
   */
  export namespace SendError {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ErrorRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Negotiation {
  /**
   * No description
   * @tags negotiation
   * @name ListNegotiationProposal
   * @summary Returns a list of the negotiation for the specified auction.
   * @request GET:/negotiation/{auctionId}
   */
  export namespace ListNegotiationProposal {
    export type RequestParams = {
      /** @format int64 */
      auctionId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags negotiation
   * @name CreateNegotiationProposal
   * @summary Creates a new proposal in the negotiation for the specified auction.
   * @request POST:/negotiation/{auctionId}
   */
  export namespace CreateNegotiationProposal {
    export type RequestParams = {
      /** @format int64 */
      auctionId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = NegotiationCreateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags negotiation
   * @name UpdateNegotiationProposal
   * @summary Moves the negotiation of a specified auction to the specified state.
   * @request PATCH:/negotiation/{auctionId}
   */
  export namespace UpdateNegotiationProposal {
    export type RequestParams = {
      /** @format int64 */
      auctionId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = NegotiationProposalUpdateRequest;
    export type RequestHeaders = {
      /** @default "{}" */
      'x-feature-flags': string;
    };
    export type ResponseBody = any;
  }
}

export namespace PaymentsOnHold {
  /**
   * @description Retrieve the amount of payment on hold for the dealer
   * @tags post-sale
   * @name GetPostSaleSummary
   * @request POST:/payments-on-hold/summary
   */
  export namespace GetPostSaleSummary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PostSalePaymentsOnHoldRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * @description Retrieve metadata for payments on hold feature
   * @tags post-sale
   * @name GetPaymentsOnHoldMetadata
   * @request GET:/payments-on-hold/list/metadata
   */
  export namespace GetPaymentsOnHoldMetadata {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * @description Deletes a previously uploaded seller funding document
   * @name DeletePaymentOnHoldDocument
   * @request DELETE:/payments-on-hold/remove/document/{documentId}
   */
  export namespace DeletePaymentOnHoldDocument {
    export type RequestParams = {
      /** @format int32 */
      documentId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * @description Submits uploaded seller funding documents
   * @tags post-sale
   * @name SubmitPaymentOnHoldDocuments
   * @request POST:/payments-on-hold/document/submit
   */
  export namespace SubmitPaymentOnHoldDocuments {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PostSalePaymentsOnHoldSubmitDocRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * @description Generates a presigned url to upload payment on hold document to
   * @tags post-sale
   * @name GeneratePresignedUrl
   * @request POST:/payments-on-hold/generate-presigned-urls
   */
  export namespace GeneratePresignedUrl {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PostSalePaymentsOnHoldUploadDocRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * @description Generates a presigned url to upload payment on hold document to
   * @tags post-sale
   * @name UpdatePaymentOnHoldDocumentStatus
   * @request POST:/payments-on-hold/document/status/update
   */
  export namespace UpdatePaymentOnHoldDocumentStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PostSalePaymentsOnHoldUpdateDocStatusRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * @description Fetches previously uploaded seller funding documents
   * @name FetchPaymentOnHoldDocuments
   * @request GET:/payments-on-hold/trade/{tradeId}/documents/{documentType}
   */
  export namespace FetchPaymentOnHoldDocuments {
    export type RequestParams = {
      /** @format int32 */
      documentType: number;
      /** @format int32 */
      tradeId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Trade {
  /**
   * @description Produces a list of trades for a buyer for a given search term, pagination, and sort, this list of trades include all trade in all states available to the buyer
   * @name TradeSearchBuy
   * @request POST:/trade/search/buy
   */
  export namespace TradeSearchBuy {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = SearchResult[];
  }
  /**
   * @description Produces a list of trades for a seller for a given search term, pagination, and sort, this list of trades include all trade in all states available to the seller
   * @name TradeSearchSell
   * @request POST:/trade/search/sell
   */
  export namespace TradeSearchSell {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = SearchResult[];
  }
  /**
   * No description
   * @tags trade-list-controller
   * @name ListSellPending
   * @request POST:/trade/list/sell/pending
   */
  export namespace ListSellPending {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PendingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PendingResponse;
  }
  /**
   * No description
   * @tags trade-list-controller
   * @name ListBuy
   * @request POST:/trade/list/buy/{tradeState}
   */
  export namespace ListBuy {
    export type RequestParams = {
      tradeState:
        | 'PARKED'
        | 'ACTIVE'
        | 'LOST'
        | 'ARRIVED'
        | 'WON'
        | 'DELIVERED'
        | 'CLOSING'
        | 'PENDING'
        | 'ORPHANED'
        | 'CONSIGNED'
        | 'UPCOMING'
        | 'BUYNOW'
        | 'UNKNOWN';
    };
    export type RequestQuery = {};
    export type RequestBody = TradeListRequest;
    export type RequestHeaders = {};
    export type ResponseBody = TradeResponse[];
  }
  /**
   * No description
   * @tags trade-list-controller
   * @name ListBuyPending
   * @request POST:/trade/list/buy/pending
   */
  export namespace ListBuyPending {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PendingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PendingResponse;
  }
  /**
   * @description Retrieve trade list with payments on hold
   * @tags post-sale
   * @name GetPostSaleTradeList
   * @request POST:/trade/payments-on-hold/list
   */
  export namespace GetPostSaleTradeList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PostSaleTradeListRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 *
 * This is a manually created swagger doc for tr-list trade search
 */
export class ApiClient<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  user = {
    /**
     * No description
     *
     * @tags user
     * @name List
     * @summary Return all user preferences.
     * @request GET:/user/preferences
     */
    list: (params: RequestParams = {}) =>
      this.request<any, UserPreferenceResponse>({
        path: `/user/preferences`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name Update
     * @summary Update user preferences.
     * @request PUT:/user/preferences
     */
    update: (data: UserPreferenceRequest, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/user/preferences`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  research = {
    /**
     * No description
     *
     * @tags research
     * @name List
     * @summary Handles the trade research request for Adesa Market Guide
     * @request POST:/research/trade/list
     */
    list: (data: AdesaResearchRequest, params: RequestParams = {}) =>
      this.request<any, TradeSummaryList>({
        path: `/research/trade/list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags research
     * @name Metadata
     * @summary Returns AMG metadata required to perform research requests
     * @request POST:/research/metadata
     */
    metadata: (data: ResearchMetadataRequest, params: RequestParams = {}) =>
      this.request<any, ResearchMetadata>({
        path: `/research/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  disclosure = {
    /**
     * No description
     *
     * @tags disclosure
     * @name ListDisclosures
     * @summary Returns a list of all the Disclosure data related to the type (Conditiion, Vehicle History) for a specified trade.
     * @request GET:/disclosure/{type}/trade/{tradeId}
     */
    listDisclosures: (type: DisclosureType, tradeId: number, params: RequestParams = {}) =>
      this.request<any, DisclosureResponse>({
        path: `/disclosure/${type}/trade/${tradeId}`,
        method: 'GET',
        ...params,
      }),
  };
  chat = {
    /**
     * No description
     *
     * @tags chat
     * @name List
     * @summary Return the list of chat messages of an auction.
     * @request GET:/chat/auction/{auctionId}
     */
    list: (auctionId: number, params: RequestParams = {}) =>
      this.request<any, ChatListResponse>({
        path: `/chat/auction/${auctionId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags chat
     * @name Create
     * @summary Create a chat message for an existing auction.
     * @request POST:/chat/auction/{auctionId}
     */
    create: (auctionId: number, data: ChatCreateRequest, params: RequestParams = {}) =>
      this.request<any, ChatMessageResponse>({
        path: `/chat/auction/${auctionId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags chat
     * @name Count
     * @summary Return the public and pending chat message counts for an auction.
     * @request GET:/chat/auction/{auctionId}/count
     */
    count: (auctionId: number, params: RequestParams = {}) =>
      this.request<any, ChatCountResponse>({
        path: `/chat/auction/${auctionId}/count`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags chat
     * @name Reply
     * @summary Create a reply to an existing message.
     * @request POST:/chat/{chatMessageId}/reply
     */
    reply: (chatMessageId: number, data: ChatCreateRequest, params: RequestParams = {}) =>
      this.request<any, ChatMessageResponse>({
        path: `/chat/${chatMessageId}/reply`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags chat
     * @name Ignore
     * @summary Mark the chat message as ignored by the user.
     * @request PUT:/chat/{chatMessageId}/ignore
     */
    ignore: (chatMessageId: number, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/chat/${chatMessageId}/ignore`,
        method: 'PUT',
        ...params,
      }),
  };
  retail = {
    /**
     * No description
     *
     * @tags retail
     * @name Create
     * @summary Create a retail trade equivalent for an existing trade.
     * @request POST:/retail/trade/{tradeId}
     */
    create: (tradeId: number, data: RetailCreateRequest, params: RequestParams = {}) =>
      this.request<any, RetailResponse>({
        path: `/retail/trade/${tradeId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags retail
     * @name FetchRetailTrade
     * @summary Return the retail trade given a retail guid
     * @request GET:/retail/token/{guid}
     */
    fetchRetailTrade: (guid: string, params: RequestParams = {}) =>
      this.request<any, RetailResponse>({
        path: `/retail/token/${guid}`,
        method: 'GET',
        ...params,
      }),
  };
  dealer = {
    /**
     * No description
     *
     * @tags dealer
     * @name UpdateDefaultPaymentMethod
     * @summary Update Dealer's default-payment-method
     * @request PUT:/dealer/payment/default
     */
    updateDefaultPaymentMethod: (data: UpdateDefaultPaymentMethodRequest, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/dealer/payment/default`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetPresignedUrls
     * @request GET:/dealer/settings/generate-presigned-urls
     */
    getPresignedUrls: (
      query?: {
        fileType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PresignedUrlForDealerLogoResponse, any>({
        path: `/dealer/settings/generate-presigned-urls`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  settings = {
    /**
     * No description
     *
     * @tags dealer
     * @name GetCustomizationMetadata
     * @summary Get customization settings on Retail Tools
     * @request GET:/settings/customization/metadata
     */
    getCustomizationMetadata: (params: RequestParams = {}) =>
      this.request<CustomizationMetadata, any>({
        path: `/settings/customization/metadata`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetDealerRetailInfo
     * @summary Get Dealer Retail settings
     * @request GET:/settings/customization
     */
    getDealerRetailInfo: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/settings/customization`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dealer
     * @name UpdateDealerRetailInfo
     * @summary Update Dealer retail settings
     * @request PUT:/settings/customization
     */
    updateDealerRetailInfo: (data: any, params: RequestParams = {}) =>
      this.request<Object, any>({
        path: `/settings/customization`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags autowin
     * @name GetAutoWinSetting
     * @summary Returns the autowin setting of dealer
     * @request GET:/settings/autowin
     */
    getAutoWinSetting: (params: RequestParams = {}) =>
      this.request<any, AutoWinSettingResponse>({
        path: `/settings/autowin`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags autowin
     * @name UpdateAutoWinSetting
     * @summary Updates the autowin setting of dealer
     * @request PATCH:/settings/autowin
     */
    updateAutoWinSetting: (data: AutoWinSettingUpdateRequest, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/settings/autowin`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  carfax = {
    /**
     * No description
     *
     * @tags carfax
     * @name ReceiveCarFaxHistoryReport
     * @summary Receive CarFax vehicle history disclosures
     * @request POST:/carfax/history-report
     */
    receiveCarFaxHistoryReport: (data: CarFaxDisclosuresRequest, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/carfax/history-report`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  okta = {
    /**
     * No description
     *
     * @tags okta
     * @name OneTimeVerification
     * @summary OKTA one time verification
     * @request GET:/okta/sync-user-profile
     */
    oneTimeVerification: (params: RequestParams = {}) =>
      this.request<any, OktaOneTimeVerificationResponse>({
        path: `/okta/sync-user-profile`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags okta
     * @name SyncUserProfile
     * @summary Sync user profile
     * @request POST:/okta/sync-user-profile
     */
    syncUserProfile: (data: OktaWebHookSyncUserRequest, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/okta/sync-user-profile`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @tags enterprisecheckout
     * @name PurchaseEventsReceive
     * @summary Purchase Event Receive
     * @request POST:/api/v4/PurchaseEvents/Receive
     */
    purchaseEventsReceive: (data: PurchaseEventRequest, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/api/v4/PurchaseEvents/Receive`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Called by the UI from Payment on Hold Page. OrganizationIds must be specified otherwise no results will be returned. Default sort order is purchase date descending
     *
     * @tags PaymentOnHold
     * @name PaymentOnHoldSearchList
     * @summary List purchases which are in payment hold status
     * @request POST:/api/v4/PaymentOnHold/search
     * @secure
     */
    paymentOnHoldSearchList: (data: PaymentOnHoldSearchRequest, params: RequestParams = {}) =>
      this.request<PaymentOnHoldResponsePagedResponse, void>({
        path: `/api/v4/PaymentOnHold/search`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Called by the UI from Payment on Hold Page. OrganizationIds must be specified otherwise no results will be returned. Default sort order is purchase date descending
     *
     * @tags PaymentOnHold
     * @name PaymentOnHoldList
     * @summary List purchases which are in payment hold status
     * @request POST:/api/v4/PaymentOnHold
     * @secure
     */
    paymentOnHoldList: (data: PaymentOnHoldSearchRequest, params: RequestParams = {}) =>
      this.request<PaymentOnHoldResponsePagedResponse, void>({
        path: `/api/v4/PaymentOnHold`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentOnHold
     * @name PaymentOnHoldSummaryList
     * @summary Get summary of PaymentOnHold purchases by organization ids
     * @request POST:/api/v4/PaymentOnHold/summary
     * @secure
     */
    paymentOnHoldSummaryList: (data: PaymentOnHoldSummaryRequest, params: RequestParams = {}) =>
      this.request<PaymentOnHoldSummaryResponse, void>({
        path: `/api/v4/PaymentOnHold/summary`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentOnHold
     * @name PostPaymentOnHoldPurchaseIdDocumentUploadTokens
     * @summary Obtain a pre-signed URL to upload a document
     * @request POST:/api/v4/PaymentOnHold/{purchaseId}/DocumentUploadTokens
     * @secure
     */
    postPaymentOnHoldPurchaseIdDocumentUploadTokens: (
      purchaseId: string,
      data: UploadAttachmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<UploadAttachmentResponse, void>({
        path: `/api/v4/PaymentOnHold/${purchaseId}/DocumentUploadTokens`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentOnHold
     * @name PostPaymentOnHoldPurchaseIdDocuments
     * @summary Upload a document to SF
     * @request POST:/api/v4/PaymentOnHold/{purchaseId}/Documents
     * @secure
     */
    postPaymentOnHoldPurchaseIdDocuments: (
      purchaseId: string,
      data: PaymentOnHoldUploadDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v4/PaymentOnHold/${purchaseId}/Documents`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  enterprisecheckout = {
    /**
     * No description
     *
     * @tags enterprisecheckout
     * @name HandleGetDocuments
     * @summary Fetch Vehicle Documents (BOS, VRF)
     * @request GET:/enterprisecheckout/documents/{documentType}/{customerType}/{sourcePurchaseId}
     */
    handleGetDocuments: (
      sourcePurchaseId: SourcePurchaseId,
      documentType: DocumentType,
      customerType: CustomerType,
      params: RequestParams = {},
    ) =>
      this.request<any, Object>({
        path: `/enterprisecheckout/documents/${documentType}/${customerType}/${sourcePurchaseId}`,
        method: 'GET',
        ...params,
      }),
  };
  kcl = {
    /**
     * No description
     *
     * @tags kcl
     * @name RetrieveEvent
     * @summary Webhook to retrieve listing event notifications from KCL
     * @request POST:/kcl/event/listing/{listingID}
     */
    retrieveEvent: (listingId: number, data: NotificationRequest, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/kcl/event/listing/${listingId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  dealers = {
    /**
     * No description
     *
     * @tags badge
     * @name GetBadges
     * @summary Get the list of badges based on a dealer Id.
     * @request GET:/dealers/{dealerId}/badges
     */
    getBadges: (dealerId: number, params: RequestParams = {}) =>
      this.request<any, BadgeResponse[]>({
        path: `/dealers/${dealerId}/badges`,
        method: 'GET',
        ...params,
      }),
  };
  tradein = {
    /**
     * No description
     *
     * @tags tradein
     * @name Verify
     * @summary Verify phone number
     * @request POST:/tradein/verify
     */
    verify: (data: TradeInVerifyRequest, params: RequestParams = {}) =>
      this.request<any, TradeInVerifyResponse>({
        path: `/tradein/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tradein
     * @name Check
     * @summary Verify twilio code
     * @request POST:/tradein/check
     */
    check: (data: TradeInCheckRequest, params: RequestParams = {}) =>
      this.request<any, TradeInCheckResponse>({
        path: `/tradein/check`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tradein
     * @name DealerLocator
     * @summary Returns the list of dealer close to the specified location lat/long
     * @request POST:/tradein/dealer-locator
     */
    dealerLocator: (data: TradeInDealerLocatorRequest, params: RequestParams = {}) =>
      this.request<any, TradeInDealerLocatorResponse[]>({
        path: `/tradein/dealer-locator`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  instrumentation = {
    /**
     * No description
     *
     * @tags instrumentation
     * @name SendError
     * @summary Report an error that occured on a client application
     * @request POST:/instrumentation/senderror
     */
    sendError: (data: ErrorRequest, params: RequestParams = {}) =>
      this.request<any, Void>({
        path: `/instrumentation/senderror`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  negotiation = {
    /**
     * No description
     *
     * @tags negotiation
     * @name ListNegotiationProposal
     * @summary Returns a list of the negotiation for the specified auction.
     * @request GET:/negotiation/{auctionId}
     */
    listNegotiationProposal: (auctionId: number, params: RequestParams = {}) =>
      this.request<any, NegotiationListResponse>({
        path: `/negotiation/${auctionId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags negotiation
     * @name CreateNegotiationProposal
     * @summary Creates a new proposal in the negotiation for the specified auction.
     * @request POST:/negotiation/{auctionId}
     */
    createNegotiationProposal: (auctionId: number, data: NegotiationCreateRequest, params: RequestParams = {}) =>
      this.request<any, NegotiationProposal>({
        path: `/negotiation/${auctionId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags negotiation
     * @name UpdateNegotiationProposal
     * @summary Moves the negotiation of a specified auction to the specified state.
     * @request PATCH:/negotiation/{auctionId}
     */
    updateNegotiationProposal: (
      auctionId: number,
      data: NegotiationProposalUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, NegotiationProposalUpdateResponse>({
        path: `/negotiation/${auctionId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  paymentsOnHold = {
    /**
     * @description Retrieve the amount of payment on hold for the dealer
     *
     * @tags post-sale
     * @name GetPostSaleSummary
     * @request POST:/payments-on-hold/summary
     */
    getPostSaleSummary: (data: PostSalePaymentsOnHoldRequest, params: RequestParams = {}) =>
      this.request<any, PostSaleSummary>({
        path: `/payments-on-hold/summary`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve metadata for payments on hold feature
     *
     * @tags post-sale
     * @name GetPaymentsOnHoldMetadata
     * @request GET:/payments-on-hold/list/metadata
     */
    getPaymentsOnHoldMetadata: (params: RequestParams = {}) =>
      this.request<any, PaymentsOnHoldMetadata>({
        path: `/payments-on-hold/list/metadata`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Deletes a previously uploaded seller funding document
     *
     * @name DeletePaymentOnHoldDocument
     * @request DELETE:/payments-on-hold/remove/document/{documentId}
     */
    deletePaymentOnHoldDocument: (documentId: number, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/payments-on-hold/remove/document/${documentId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Submits uploaded seller funding documents
     *
     * @tags post-sale
     * @name SubmitPaymentOnHoldDocuments
     * @request POST:/payments-on-hold/document/submit
     */
    submitPaymentOnHoldDocuments: (data: PostSalePaymentsOnHoldSubmitDocRequest, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/payments-on-hold/document/submit`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates a presigned url to upload payment on hold document to
     *
     * @tags post-sale
     * @name GeneratePresignedUrl
     * @request POST:/payments-on-hold/generate-presigned-urls
     */
    generatePresignedUrl: (data: PostSalePaymentsOnHoldUploadDocRequest, params: RequestParams = {}) =>
      this.request<any, PostSalePaymentsOnHoldUploadDocResponse>({
        path: `/payments-on-hold/generate-presigned-urls`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates a presigned url to upload payment on hold document to
     *
     * @tags post-sale
     * @name UpdatePaymentOnHoldDocumentStatus
     * @request POST:/payments-on-hold/document/status/update
     */
    updatePaymentOnHoldDocumentStatus: (
      data: PostSalePaymentsOnHoldUpdateDocStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/payments-on-hold/document/status/update`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches previously uploaded seller funding documents
     *
     * @name FetchPaymentOnHoldDocuments
     * @request GET:/payments-on-hold/trade/{tradeId}/documents/{documentType}
     */
    fetchPaymentOnHoldDocuments: (documentType: number, tradeId: number, params: RequestParams = {}) =>
      this.request<any, PostSalePaymentsOnHoldUploadDocResponse>({
        path: `/payments-on-hold/trade/${tradeId}/documents/${documentType}`,
        method: 'GET',
        ...params,
      }),
  };
  trade = {
    /**
     * @description Produces a list of trades for a buyer for a given search term, pagination, and sort, this list of trades include all trade in all states available to the buyer
     *
     * @name TradeSearchBuy
     * @request POST:/trade/search/buy
     */
    tradeSearchBuy: (data: SearchRequest, params: RequestParams = {}) =>
      this.request<SearchResult[], void>({
        path: `/trade/search/buy`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Produces a list of trades for a seller for a given search term, pagination, and sort, this list of trades include all trade in all states available to the seller
     *
     * @name TradeSearchSell
     * @request POST:/trade/search/sell
     */
    tradeSearchSell: (data: SearchRequest, params: RequestParams = {}) =>
      this.request<SearchResult[], void>({
        path: `/trade/search/sell`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags trade-list-controller
     * @name ListSellPending
     * @request POST:/trade/list/sell/pending
     */
    listSellPending: (data: PendingRequest, params: RequestParams = {}) =>
      this.request<PendingResponse, any>({
        path: `/trade/list/sell/pending`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags trade-list-controller
     * @name ListBuy
     * @request POST:/trade/list/buy/{tradeState}
     */
    listBuy: (
      tradeState:
        | 'PARKED'
        | 'ACTIVE'
        | 'LOST'
        | 'ARRIVED'
        | 'WON'
        | 'DELIVERED'
        | 'CLOSING'
        | 'PENDING'
        | 'ORPHANED'
        | 'CONSIGNED'
        | 'UPCOMING'
        | 'BUYNOW'
        | 'UNKNOWN',
      data: TradeListRequest,
      params: RequestParams = {},
    ) =>
      this.request<TradeResponse[], any>({
        path: `/trade/list/buy/${tradeState}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags trade-list-controller
     * @name ListBuyPending
     * @request POST:/trade/list/buy/pending
     */
    listBuyPending: (data: PendingRequest, params: RequestParams = {}) =>
      this.request<PendingResponse, any>({
        path: `/trade/list/buy/pending`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve trade list with payments on hold
     *
     * @tags post-sale
     * @name GetPostSaleTradeList
     * @request POST:/trade/payments-on-hold/list
     */
    getPostSaleTradeList: (data: PostSaleTradeListRequest, params: RequestParams = {}) =>
      this.request<any, PostSaleTradeListResponse>({
        path: `/trade/payments-on-hold/list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
}
